// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlerErrorResponse
 */
export interface HandlerErrorResponse {
  /**
   *
   * @type {string}
   * @memberof HandlerErrorResponse
   */
  error?: string;
}

/**
 * Check if a given object implements the HandlerErrorResponse interface.
 */
export function instanceOfHandlerErrorResponse(
  value: object,
): value is HandlerErrorResponse {
  return true;
}

export function HandlerErrorResponseFromJSON(json: any): HandlerErrorResponse {
  return HandlerErrorResponseFromJSONTyped(json, false);
}

export function HandlerErrorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerErrorResponse {
  if (json == null) {
    return json;
  }
  return {
    error: json['error'] == null ? undefined : json['error'],
  };
}

export function HandlerErrorResponseToJSON(json: any): HandlerErrorResponse {
  return HandlerErrorResponseToJSONTyped(json, false);
}

export function HandlerErrorResponseToJSONTyped(
  value?: HandlerErrorResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    error: value['error'],
  };
}
